module.exports = __webpack_public_path__ + "static/smr_header.d6accfe5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/smr_header.jpg
// module id = 3210
// module chunks = 188370110548916